import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=1a5991c1&scoped=true&"
import script from "./Instruments.vue?vue&type=script&lang=js&"
export * from "./Instruments.vue?vue&type=script&lang=js&"
import style0 from "./Instruments.vue?vue&type=style&index=0&id=1a5991c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5991c1",
  null
  
)

export default component.exports